"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subtitle = exports.Label = void 0;
var tslib_1 = require("tslib");
var ui_blocks_1 = require("@hopin-team/ui-blocks");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_text_1 = require("@hopin-team/ui-text");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var base = ui_blocks_1.INTERACTIVE.base;
exports.Label = (0, styled_components_1.default)(ui_text_1.Text).attrs(function () { return ({ element: 'label' }); })(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  user-select: none;\n  color: ", ";\n  ", ";\n  cursor: ", ";\n"], ["\n  user-select: none;\n  color: ", ";\n  ", ";\n  cursor: ", ";\n"])), function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled && (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["600"]', theme);
}, base, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
});
exports.Subtitle = (0, styled_components_1.default)(ui_text_1.Text)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  line-height: 1.25rem;\n"], ["\n  line-height: 1.25rem;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=label.js.map